import { createContext } from "react";
import type { ContactsAdapter } from "./types";
import { createMockContactsAdapter } from "./mock/mockAdapter";
import { LiveContactsAdapter } from "./live/liveAdapter";

/**
 * Contacts adapter selection (W3). Env-driven, mock by default. W3a ships
 * mock-first; W3b flips `VITE_CONTACTS_ADAPTER_MODE=live` once the backend
 * CRUD Edge Functions exist.
 */

export type ContactsAdapterMode = "mock" | "live";

export const CONTACTS_ADAPTER_MODE: ContactsAdapterMode =
  import.meta.env.VITE_CONTACTS_ADAPTER_MODE === "live" ? "live" : "mock";

function selectContactsAdapter(): ContactsAdapter {
  return CONTACTS_ADAPTER_MODE === "live"
    ? new LiveContactsAdapter()
    : createMockContactsAdapter();
}

export const defaultContactsAdapter = selectContactsAdapter();

export const ContactsAdapterContext =
  createContext<ContactsAdapter>(defaultContactsAdapter);
